module.exports = __webpack_public_path__ + "static/media/8.d64ab5f8.jpg";